export const ANNOTATION_BASE_URI = "https://deg.byu.edu/";
export const BUTTON_CLASS = "btn waves-effect waves-light blue";
export const BASE_URI = "https://comet.byu.edu/api/";
export const COLOR_COUNT = 8;
export const DEBUG_CACHE = false;
export const FIELD_TYPE_MULTIPLE = "multiple";
export const FIELD_TYPE_SINGLE = "single";
export const FORM_WIDTH_FACTOR_NORMAL = 0.5;
export const FORM_WIDTH_FACTOR_WIDE = 0.60;
export const HIGHLIGHT_COLORS = [ {r: 0xFF, g: 0x00, b: 0x00, a: 0.3},
                                  {r: 0x00, g: 0xFF, b: 0x00, a: 0.3},
                                  {r: 0x00, g: 0x00, b: 0xFF, a: 0.3},
                                  {r: 0xFF, g: 0xFF, b: 0x00, a: 0.3},
                                  {r: 0x94, g: 0x00, b: 0xD3, a: 0.3},
                                  {r: 0x00, g: 0xFF, b: 0xFF, a: 0.3},
                                  {r: 0xFF, g: 0x8C, b: 0x00, a: 0.3},
                                  {r: 0x32, g: 0xCD, b: 0x32, a: 0.3} ];
export const HINT_TYPE_BREAK = "break";
export const HINT_TYPE_INDENT = "indent";
export const HTTP_STATUS_OK = 200;
export const INSERT_AFTER = 1;
export const INSERT_BEFORE = 0;
export const KEY_CODE = {
    backspace: 8,
    tab: 9,
    shift: 16,
    ctrlLeft: 17,
    alt: 18,
    esc: 27,
    del: 46,
    digit0: 48,
    digit1: 49,
    digit9: 57,
    capA: 65,
    capX: 88,
    ctrlRight: 91,
    smallA: 97,
    dash: 109,
    smallX: 120,
    minus: 189
};
export const WIDE_FORMS = ["Individual", "Person"];
export const ZOOM_DELTA = 0.10;
export const ZOOM_FACTOR = 0.55;
